// /stacks/traffic/dev/frontend/src/lib/format.js
// Shared formatters used by Stats & Sightings

export const nf = new Intl.NumberFormat("en-US");

export function num(v) {
  // Coerce "6,691" or undefined/null to a number
  if (v == null) return 0;
  if (typeof v === "number") return v;
  const s = String(v).replace(/,/g, "");
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
}

// Friendly timestamp for UI tables/cards. Accepts "YYYY-MM-DD HH:MM:SS" or ISO.
export function toHumanTimestamp(input) {
  if (!input) return "";
  const s = String(input).replace(" ", "T"); // handle SQL-style "YYYY-MM-DD HH:MM:SS"
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return String(input);

  // Match the human style we use elsewhere: YYYY-MM-DD + 12-hour with seconds
  const yyyy = d.getFullYear();
  const MM = String(d.getMonth() + 1).padStart(2, "0");
  const DD = String(d.getDate()).padStart(2, "0");
  const time = d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
  });
  return `${yyyy}-${MM}-${DD} ${time}`;
}
